/**
 * Card de projeção — a resposta do VITA depois do ritmo.
 * Fonte: Objetivo.dc.html (`temProj`) e § 3 do 12-prompt.
 *
 * A LINHA SE DESENHA: `stroke-dasharray: 600` com `dashoffset` indo de 600 a 0
 * em 1.4s. É o que transforma um gráfico num "olha o que vai acontecer" — e é
 * por isso que a curva tem uma ondulação decrescente em vez de ser uma reta:
 * peso real não sobe em linha, e uma reta prometeria uma regularidade que não
 * existe.
 *
 * OS NÚMEROS SÃO DERIVADOS DO QUE A PESSOA JÁ RESPONDEU — peso atual, meta e
 * ritmo. Nada de chamada nova, nada de campo novo. Se faltar qualquer um dos
 * três, o card não aparece: projeção com dado faltando seria adivinhação
 * apresentada como cálculo.
 *
 * Cálculo em `projecaoDePeso` (módulo puro, com teste).
 */

import React, { useMemo } from 'react';

import { projecaoDePeso } from './projecao';
import s from './CardDeProjecao.module.scss';

export default function CardDeProjecao({ answers = {} }) {
  const p = useMemo(() => projecaoDePeso(answers), [answers]);
  if (!p) return null;

  return (
    <div className={s.card}>
      <div className={s.topo}>
        <span className={s.titulo}>{p.titulo}</span>
        <span className={s.meta}>{p.resumo}</span>
      </div>

      <svg className={s.grafico} viewBox="0 0 300 120" aria-hidden="true">
        <defs>
          {/* id por instância: dois cards na mesma tela com id fixo colidem
              e o segundo pinta com o gradiente do primeiro (lacuna 2). */}
          <linearGradient id={p.idDoGradiente} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#3A55E0" stopOpacity=".45" />
            <stop offset="1" stopColor="#3A55E0" stopOpacity="0" />
          </linearGradient>
        </defs>

        <line
          x1="0"
          y1="12"
          x2="300"
          y2="12"
          stroke="rgba(251,189,4,.5)"
          strokeWidth="1"
          strokeDasharray="4 5"
        />
        <text x="0" y="8" className={s.rotuloMeta}>Meta</text>

        <path d={p.area} fill={`url(#${p.idDoGradiente})`} />
        <path className={s.linha} d={p.caminho} fill="none" stroke="#8FA2FF" strokeWidth="2.5" strokeLinecap="round" />

        <circle cx="300" cy="12" r="5" fill="#0A0C14" stroke="#FBBD04" strokeWidth="2.5" />

        <text x="0" y="116" className={s.data}>{p.dataInicial}</text>
        <text x="300" y="116" textAnchor="end" className={s.data}>{p.dataFinal}</text>
      </svg>

      <span className={s.nota}>{p.nota}</span>
    </div>
  );
}
